import { render, staticRenderFns } from "./DeleteTeamMember.vue?vue&type=template&id=b8dd1208&"
import script from "./DeleteTeamMember.vue?vue&type=script&lang=js&"
export * from "./DeleteTeamMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports